// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__-KZo3","overflowing":"ReadFullNote_overflowing__3t_Jk"};